import angular from 'angular';

export class FooterComponent {
  constructor($state) {
    'ngInject';

    this.$state = $state;
    this.isFrontpage = false;
    this.year = (new Date()).getFullYear();
  }

  $doCheck() {
    this.isFrontpage = this.$state.current.name == 'main';

    if (this.isFrontpage)
      jQuery("body").addClass("frontpage-footer-background");
    else
      jQuery("body").removeClass("frontpage-footer-background");
  }
}

/**
 * @ngdoc directive
 * @name angular-test2.directive:footer
 * @element footer
 * @function
 *
 * @description
 * Renders the footer of the page
 *
 * **Note:** nothing special, just the test of a note
 *
 * @example
 <example module="angular-test2">
 <file name="index.html">
   <footer />
 </file>
 </example>
 */
export default angular.module('directives.footer', [])
  .component('footer', {
    template: require('./footer.html'),
    controller: FooterComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/footer/footer.component.js